import dstoreSettings from "../services/dstore.settings";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        settings: [],
        errors: null,
        brand_categories: [],
        product_categories: [],
        bank_accounts: [],
        payment_type: [],
        fees: [],
        brands: [],
        loyaltyVisibility: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        settings(state, settings) {
            state.settings = settings;
        },
        brand_categories(state, brand_categories) {
            state.brand_categories = brand_categories;
        },
        product_categories(state, product_categories) {
            state.product_categories = product_categories;
        },
        bank_accounts(state, bank_accounts) {
            state.bank_accounts = bank_accounts;
        },
        payment_type(state, payment_type) {
            state.payment_type = payment_type;
        },
        fees(state, fees) {
            state.fees = fees;
        },
        brands(state, brands) {
            state.brands = brands;
        },
        loyaltyVisibility(state, loyaltyVisibility) {
            state.loyaltyVisibility = loyaltyVisibility;
        }
    },
    actions: {
        async saveFees({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreSettings.saveFees(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save fees.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewFees({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await dstoreSettings.viewFees();
                commit("fees", response.list);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async deleteFees({ commit }, uuid) {
            commit("loading");
            try {
                let response = await dstoreSettings.deleteFees(uuid);
                notification.success(response.message);
                // commit("deleted", response);
            } catch (errors) {
                notification.error(errors.message);
                commit("errors", errors);
            }
        },
        async saveSettings({ commit }, param) {
            commit("loading");
            try {
                let response = await dstoreSettings.saveSettings(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot save settings.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async viewSettings({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await dstoreSettings.viewSettings();
                // console.log(response);
                // if (response.settings.categories.length > 0) {
                //     response.settings.categories.forEach(category => {
                //         if (category.sub_categories.length == 0) {
                //             category.sub_categories = [
                //                 {
                //                     uuid: "",
                //                     name: ""
                //                 }
                //             ];
                //         }
                //     });
                // }

                if (response.data.sku_stock == "1") {
                    response.data.sku_stock = true;
                } else {
                    response.data.sku_stock = false;
                }

                if (response.data.recipient_mobile_number == "1") {
                    response.data.recipient_mobile_number = true;
                } else {
                    response.data.recipient_mobile_number = false;
                }

                if (response.data.category_enable == "1") {
                    response.data.category_enable = true;
                } else {
                    response.data.category_enable = false;
                }

                if (response.data.fees_enable == "1") {
                    response.data.fees_enable = true;
                } else {
                    response.data.fees_enable = false;
                }

                // if (response.settings.brand_categories_enable == "1") {
                //     response.settings.brand_categories_enable = true;
                // } else {
                //     response.settings.brand_categories_enable = false;
                // }

                // if (response.settings.bank_accounts.length === 0) {
                //     response.settings.bank_accounts = [
                //         {
                //             bank: "",
                //             account_name: "",
                //             account_no: "",
                //             uuid: ""
                //         }
                //     ];
                // }
                commit("settings", response.data);
                // commit(
                //     "brand_categories",
                //     response.settings.brand_categories.map(obj => {
                //         let rBrand = {};
                //         rBrand["id"] = obj.uuid;
                //         rBrand["name"] = obj.name;
                //         return rBrand;
                //     })
                // );

                // commit("payment_type", response.settings.payment_type);
                // commit("product_categories", response.settings.categories);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getBrands({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await dstoreSettings.getBrands();
                commit("brands", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getLoyaltyVisibility({ commit }) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await dstoreSettings.getLoyaltyVisibility();
                commit("loyaltyVisibility", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        }
    }
};
